import { Button, Grid } from '@material-ui/core';
import * as React from 'react';
import { useContext, useState } from 'react';
import { BulkResponseDialog } from '../common/BulkResponseDialog';
import { AuthContext } from '../_auth/AuthContext';
import { UnfreezeMemberships } from '../_service/bulk';
import { BulkUtilResponse } from '../_types/bulk';
import { ISearchResult } from '../_types/search';
import { ServicePlan } from '../_types/serviceplan';
import { ILocationSummary } from '../_types/user';
import { PlanByLocationSelector } from '../common/Selector/PlanByLocationSelector';
import { BulkShowResultsListButton } from '../common/BulkShowResultsListButton';


interface Props {
  plans: ServicePlan[],
};

const UnfreezeMembers: React.FC<Props> = (prop: Props) => {
  const { user } = useContext(AuthContext);
  const [location, setLocation] = useState<ILocationSummary | ISearchResult | null>(user.currentLocation || null);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [selectedPlan, setSelectedPlan] = useState<string | null>();
  const [isUnfreezing, setIsUnfreezing] = useState<boolean>(false);
  const [emailList, setEmailList] = useState<string[]>([]);
  const [ignoreList, setIgnoreList] = useState<string[]>([]);
  const [storedEmailList, setStoredEmailList] = useState<string[] | undefined>();
  const [storedIgnoreList, setStoredIgnoreList] = useState<string[] | undefined>();

  const _unfreeze = async () => {
    if (!location) return alert('Please select a location.');
    setIsUnfreezing(true);
    let response: BulkUtilResponse | null;
    
    try {
        response = await UnfreezeMemberships(location?.id, 
          (selectedPlan && selectedPlan !== 'all plans') ? selectedPlan : null);
    } catch (error) {
      setIsUnfreezing(false);
      return alert('Something went wrong while connecting to the API. Please try again.');
    }

      if (response !== null) {
        setIsUnfreezing(false);
        setSelectedPlan(null);

        if (response.emails && response.emails.length > 0) {
          setEmailList(response.emails);
          setIsOpen(true);
        }
        
        if (response.ignoreList && response.ignoreList.length > 0) {
          setIgnoreList(response.ignoreList);
          setIsOpen(true);
        }
  
        if (response.emails && response.emails.length === 0
          && response.ignoreList && response.ignoreList.length === 0) {
            return alert('No memberships were unfrozen. Make sure you selected the correct location and/or plans.');
          }
      }
  }

  return (
    <>
      <Grid item>
        <h3>Unfreeze Members</h3>
        <p>Select a location and a plan to unfreeze the members of a given plan. You can select "All Plans" to unfreeze all members at the given location.
        </p>
      </Grid>
      <PlanByLocationSelector
        onLocationChange={(newValue: ISearchResult | null) => {
          setLocation(newValue);
        }}
        onPlanChange={(event: any) => setSelectedPlan(event.target.value as string)}
        planValue={selectedPlan || ''}
        planInputLabel='Plans'
        plans={prop.plans}
      />
      {isUnfreezing ? <p>Unfreezing, please wait... This can take several minutes...</p> :
        <>
          <div style={{ display: "flex", width: "100%" }}>
            <Grid item xs={12} sm={12} style={{ display: "flex", justifyContent: "flex-end", height: "2.85em", flexDirection: "column" }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => _unfreeze()}>
                Unfreeze
              </Button>
            </Grid>
          </div>
          <Grid item xs={12} sm={12} style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
            <BulkShowResultsListButton
              title={"Successfully Unfroze " + (storedEmailList?.length || 0).toString() + " Member Emails"}
              emailList={storedEmailList}
              ignoreList={storedIgnoreList}
              hide={storedEmailList === undefined}
              csvName={"UnfreezeMembers" + new Date().toLocaleDateString()}
            />
          </Grid>
        </>
      }
      {(emailList.length > 0 || ignoreList.length > 0) && <BulkResponseDialog
        title="Successfully Unfrozen Member Emails"
        isOpen={isOpen}
        emailList={emailList}
        ignoreList={ignoreList}
        handleClose={() => {
          setIsOpen(false);
          setStoredEmailList(emailList);
          setStoredIgnoreList(ignoreList);
          setEmailList([]);
          setIgnoreList([]);
        }} />}
    </>
  );
}

export default UnfreezeMembers;